import React, { Component } from "react";
import { connect } from "react-redux";
import { hasLocationSelector } from "../../services/location/reducer";
import Container from "../../components/Container";
import Vote from "./components/Vote";
import logo from "./logo.svg";
import "./style.css";

const mapStateToProps = state => ({
  hasLocation: hasLocationSelector(state)
});

class Intro extends Component {
  render() {
    return (
      <Container className="intro">
        <img src={logo} className="intro__logo" alt="NOS op 3" width="80" />
        <h1 className="intro__title">Hoeveel is jouw stem écht waard?</h1>
        <Vote isDone={this.props.hasLocation} />
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Intro);



// WEBPACK FOOTER //
// ./src/scenes/Intro/index.js